export const STANDARD_TEMPLATE_TASKS = [
  'Fattibilità',
  'Analisi',
  'BBP e Approvazione',
  'Sviluppo',
  'SIT',
  'UAT',
  'Go Live',
  'Post Avvio'
];

